import { render } from "./UiElementliste.pug?vue&type=template&id=3df4633b&lang=pug"
import script from "./UiElementliste.js?vue&type=script&lang=js"
export * from "./UiElementliste.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__